exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".common-content{background-color:#fafafa}.text-report-1{font-family:museosans300,arial,Tahoma;font-size:24px;line-height:34px;text-align:center;padding-bottom:20px}.text-report-2{font-family:museosans100,arial,Tahoma;padding-bottom:20px}.text-report-2,.text-report-3{font-size:18px;line-height:30px;text-align:center}.text-report-3{font-family:museosans500,arial,Tahoma;padding-bottom:60px}.report-image{max-width:1100px;margin:0 auto}@media (min-width:768px){.text-report-1{font-size:40px;line-height:50px}.text-report-2{font-size:30px;line-height:45px}.text-report-3{font-size:30px;line-height:36px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/css-loader?minimize!../common/css/report.css
// module id = 394
// module chunks = 2